module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aback5-11d5fe37246a5d0491d5de7131f12040.jpg";